import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';

import DeleteAssetModalDisplay from './DeleteAssetModalDisplay';
import AssetService from '../../Services/AssetService';

const initState = { deleteRequestPending: false, error: '' };
export default function DeleteAssetModal(props) {
  const [state, updateState] = useState(initState);

  const assetService = useMemo(() => new AssetService(), []);
  let source = CancelToken.source();

  const handleDeleteAsset = async () => {
    if (state.deleteRequestPending) return;

    updateState((prevState) => ({ ...prevState, deleteRequestPending: true }));
    source = CancelToken.source();
    try {
      const { _id, nickname } = props.assetToDelete;
      await assetService.deleteAsset(_id, source.token);
      props.handleSubtractAsset(
        _id,
        `${nickname || 'Asset'} has been deleted`,
        true
      );
    } catch (err) {
      if (isCancel(err)) return;

      updateState({
        deleteRequestPending: false,
        error: err.response?.data?.message ?? err.message,
      });
    }
  };

  useEffect(() => {
    return source.cancel;
  }, [source.cancel]);

  return (
    <DeleteAssetModalDisplay
      {...props}
      {...state}
      handleDeleteAsset={handleDeleteAsset}
    />
  );
}

DeleteAssetModal.propTypes = {
  assetToDelete: PropTypes.object,
  handleSubtractAsset: PropTypes.func,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
};
